import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.detectFraming();
  }

  detectFraming(): void {
    try {
      const isFramed = window.self !== window.top;
      if (isFramed) {
        const fallback = this.renderer.selectRootElement('#frameCheckFallback', true);
        this.renderer.setStyle(fallback, 'display', 'block');
      }
    } catch {
      const fallback = this.renderer.selectRootElement('#frameCheckFallback', true);
      this.renderer.setStyle(fallback, 'display', 'block');
    }
  }
}
